export const CHAT_ROUTES_PREFIX = "/portal/chat-page";

export const CHAT_ROUTES = {
  CHAT: CHAT_ROUTES_PREFIX,
};
